<template>
	<div>
		<svg :width="iconSize" :height="iconSize" viewBox="0 0 21 19" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path fill-rule="evenodd" clip-rule="evenodd"
				d="M19.3366 2.02239C19.118 1.31229 18.4518 0.835882 17.7092 0.858695L9.05455 1.12457L6.33797 5.19316C5.93191 5.79926 6.11218 6.60804 6.74057 6.99967C7.369 7.39131 8.20759 7.21744 8.61365 6.61138L10.4266 3.95767L10.8235 4.2069L17.9775 8.69936L19.8085 7.39167C20.3864 6.97894 20.6353 6.24269 20.4265 5.56396L19.3366 2.02239ZM3.0069 4.14811C3.34873 3.46748 4.11208 3.10933 4.85401 3.28148L5.90767 3.52596L5.24694 4.51553C4.45414 5.69885 4.80785 7.28581 6.03647 8.05152C6.46658 8.31959 6.96403 8.46125 7.47498 8.46125C8.37784 8.46125 9.20939 8.02596 9.7008 7.29657L10.8007 5.68654L17.7036 10.0213L17.7399 10.0441C18.3326 10.4454 18.4952 11.2301 18.0987 11.8218C17.6926 12.4279 16.854 12.6017 16.2256 12.2101L15.7649 11.923C16.3932 12.3147 16.5734 13.1234 16.1674 13.7294C15.7613 14.3355 14.9227 14.5093 14.2943 14.1177L13.8355 13.8314L13.9397 13.9038C14.4472 14.2908 14.5995 14.9741 14.3016 15.5281L14.236 15.637C13.83 16.243 12.9914 16.4169 12.363 16.0253L11.9045 15.7393L12.0083 15.8114C12.5159 16.1984 12.6682 16.8817 12.3703 17.4356L12.3047 17.5446C11.8987 18.1506 11.0601 18.3245 10.4316 17.9329L9.29155 17.2039L10.028 16.1047C10.8219 14.9198 10.4682 13.3328 9.23955 12.5671C8.83756 12.3165 8.37672 12.1764 7.90098 12.1591C7.6915 11.7507 7.37106 11.4026 6.96387 11.1489C6.56191 10.8984 6.10104 10.7582 5.62529 10.7409C5.41582 10.3324 5.09538 9.98439 4.68819 9.73066C4.25816 9.46267 3.76075 9.32096 3.24981 9.32092C2.34468 9.32085 1.51117 9.75832 1.0202 10.4911L0.997446 10.5251L0.903503 10.4396C0.486961 10.0237 0.378118 9.38242 0.646511 8.84801L3.0069 4.14811ZM2.11075 11.1705C2.51681 10.5645 3.3554 10.3906 3.98383 10.7822C4.61222 11.1739 4.79249 11.9827 4.38643 12.5887C4.79249 11.9827 5.63108 11.8088 6.25951 12.2005C6.8879 12.5921 7.06818 13.4009 6.66211 14.007C7.06818 13.4009 7.90677 13.227 8.53519 13.6187C9.16358 14.0103 9.34386 14.8191 8.93779 15.4252L7.54891 17.4982C7.14285 18.1043 6.30422 18.2781 5.67583 17.8865C5.04744 17.4949 4.86717 16.6861 5.27323 16.08C4.86717 16.686 4.02858 16.8599 3.40015 16.4683C2.77176 16.0766 2.59148 15.2679 2.99755 14.6618C2.59148 15.2678 1.7529 15.4417 1.12447 15.0501C0.496079 14.6584 0.315803 13.8496 0.721867 13.2436L2.11075 11.1705Z"
				:fill="color" 
			/>
		</svg>
	</div>
</template>

<script>
export default {
	name: 'IconSvgPartners',
	props: {
		color: {
			type: String,
			default: '#000000',
		},
		size: {
			type: Number,
			default: null
		}
	},
	computed: {
		iconSize() {
			return this.size ? `${this.size}px` : '44px'
		}
	}
};
</script>

<style scoped>

</style>